import { Archive, ClipboardCheck, Landmark, Users } from 'lucide-react';
import Hotspot from './Hotspot';

const STATS = [
  { label: 'Active programs', value: '4', icon: ClipboardCheck, accent: '#0f766e' },
  { label: 'Participants', value: '128', icon: Users, accent: '#5fa8d3' },
  { label: 'Pending reviews', value: '6', icon: Landmark, accent: '#d9a441' },
] as const;

/** Fictional preview only. Identity: Pacific Heritage Museum (see @/lib/demo-content). No real
 * user or institution data. */
export default function InstitutionOverviewPreview() {
  return (
    <div className="relative min-w-0">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#211b2e] text-[#d6b9ef]">
          <Landmark size={18} aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="truncate text-sm font-bold text-slate-900">Pacific Heritage Museum</p>
          <p className="truncate text-xs text-slate-500">Community Memory Archive</p>
        </div>
        <Hotspot
          label="Open program"
          note="Each program tracks its own participants, evidence and issued records."
          className="ml-auto"
        />
      </div>

      <div className="mt-4 grid grid-cols-3 gap-2">
        {STATS.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.label}
              className="rounded-[9px] border border-slate-200 bg-white p-2.5 text-center"
            >
              <span
                className="mx-auto flex h-7 w-7 items-center justify-center rounded-full"
                style={{ background: `${stat.accent}1f`, color: stat.accent }}
              >
                <Icon size={14} aria-hidden="true" />
              </span>
              <p className="mt-1.5 text-lg font-black text-slate-900">{stat.value}</p>
              <p className="truncate text-[10px] font-bold uppercase tracking-wide text-slate-500">
                {stat.label}
              </p>
            </div>
          );
        })}
      </div>

      <div className="mt-4 rounded-[9px] border border-slate-200 bg-white p-3">
        <p className="text-[11px] font-bold uppercase tracking-wide text-slate-500">
          Newcomer Listening Booth
        </p>
        <p className="mt-1 text-xs leading-6 text-slate-600">
          32 participants &middot; 12 records issued this quarter &middot; 3 awaiting review
        </p>
      </div>

      <div className="relative mt-3 flex items-center gap-3 rounded-[9px] border border-[#9a7bb8]/30 bg-[#f6f1fa] p-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#3b2d4d] text-[#d6b9ef]">
          <Archive size={14} aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="text-xs font-bold text-slate-900">Heritage Archive</p>
          <p className="truncate text-[11px] text-slate-500">
            Institutional history preserved alongside active programs
          </p>
        </div>
      </div>
    </div>
  );
}
